import _ from 'lodash';

export function isBlank(value) {
    return _.isNil(value) || _.trim(value) === '';
}
